<template>
  <div style="overflow-x: hidden;" class="trial-top-head">
    <header class="trial-re-header ">
      <div class="container">
        <div class="col-md-12">
          <img class="logo-d d-none" src="/static/front/images/trial-flow-logo.png"/>
        </div>
      </div>
    </header>
    <section class="trial-main">
      <div class="loading" v-if="loader">
        <div class="load">
          <hr><hr><hr><hr>
          <div class="loadback"></div>
        </div>
      </div>
      <div class="container welcome-sec" v-if="step === 0">
        <div class="row">
          <div class="col-md-6">
            <div class="trial-ti-sec">
              <h2>EXPERIENCE B1G1 FOR 17 DAYS AND INTEGRATE GLOBAL IMPACTS INTO YOUR BUSINESS.</h2>
              <p class="mb-2">You'll gain access to the full range of B1G1 business features and discover how the seamless integration of impacts into your everyday operations transforms your company and our world.</p>
              <p class="mb-3">Start your trial by creating a global impact with $1 of giving, funded by us!</p>
              <div class="text-center btn-sec"><a data-v-54b4acdd="" href="javascript:void(0)" @click="getStarted()" class="b-btn red-btn">GET
                STARTED</a></div>
              <div class="text-center link-sec"><a href="https://b1g1.com" target="_blank">Learn more about B1G1
                 </a> | <a href="https://account.b1g1.com/sign-up" target="_blank">Register as a
                Member </a></div>
            </div>
          </div>
          <div class="col-md-6"><img src="/static/front/images/trial-new-img.png"/></div>
        </div>
      </div>
      <div class="container" v-if="step !== 0">
        <div class="row">
          <div class="col-md-6">
            <div class="trial-ti-sec">
              <h2>{{ topHeading }}</h2>
              <p>{{ topText }}</p>
            </div>
            <div class="trial-image-sec d-block d-sm-none" v-if="step !== 2">
              <img :src="imagePath">
              <div class="trial-img-content">
                <h3>{{ textHeading }}</h3>
                <p>{{ textContent }}</p>
              </div>
            </div>
            <div class="trial-plan" v-if="step !== 2">
              <aside @click="selectProject('water')" :class="waterProjSelected">
                <h4>50 DAYS OF ACCESS TO CLEAN WATER</h4>
                <img src="/static/front/images/goal_icons/Cropped6.png"/>
              </aside>
              <aside @click="selectProject('tree')" :class="treeProjSelected">
                <h4>PLANT A TREE IN THE WORLD</h4>
                <img src="/static/front/images/goal_icons/Cropped15.png"/>
              </aside>
              <aside @click="selectProject('education')" :class="educationProjSelected">
                <h4>5 DAYS OF ACCESS TO EDUCATION</h4>
                <img src="/static/front/images/goal_icons/Cropped4.png"/>
              </aside>
            </div>
            <div class="error-me" v-if="errorMsg === 1">
              Please select one of the above impacts before you proceed.
            </div>
            <div class="text-center btn-sec" v-if="step !== 2">
              <a class="b-btn red-btn" href="javascript:void(0)" @click="submitImpact()">SUBMIT YOUR IMPACT</a>
            </div>
            <div class="trial-form" v-if="step === 2">
              <input type="hidden" name="projectId" id="projectId" v-model="form.project.id"/>
              <input type="hidden" name="impactId" id="impactId" v-model="form.project.impact_level_id"/>
              <input type="hidden" name="quantity" id="quantity" v-model="form.project.quantity"/>
              <input type="hidden" name="price" id="price" v-model="form.project.price"/>
              <p class="warning-text" v-if="user">You are currently logged in as a member and cannot submit this
                form.</p>
              <div @click="getUserWarningAlert()">
                <div class="col two-in">
                  <input type="text" :class="(getError('first_name') ? ' error' : '')" name="first_name" id="first_name"
                        placeholder="First Name" v-model="form.first_name" v-validate="'required'" maxlength="40"
                        :disabled="user">
                  <!--                <span v-show="errors.has('first_name')"-->
                  <!--                      class="help-block mt-1 p-1">The first name field is required.</span>-->
                  <input type="text" :class="(getError('last_name') ? ' error' : '')" name="last_name" id="last_name"
                        placeholder="Last Name" v-model="form.last_name" v-validate="'required'" maxlength="40"
                        :disabled="user">
                  <!--                <span v-show="errors.has('last_name')"-->
                  <!--                      class="help-block mt-1 p-1">The last name field is required.</span>-->
                </div>
                <div class="col">
                  <input type="email" :class="(getError('email') ? ' error' : '')" name="email" id="email"
                        placeholder="Email" v-model="form.email" v-validate="'required|email|uniqueEmail'"
                        :disabled="user">
                  <span v-show="errors.has('email') && errors.first('email') !== 'The email field is required'"
                        class="help-block mt-1 p-1">{{ errors.first('email') }}</span>
                </div>
                <div class="col">
                  <input type="text" :class="(getError('company') ? ' error' : '')" name="company" id="company"
                        placeholder="Company Name" v-model="form.company" v-validate="'required'"
                        v-on:keyup="checkAlphabetsOnly('company')" :disabled="user">
                  <span v-show="errors.has('company')"
                        class="help-block mt-1 p-1">{{ errors.first('company') }}</span>
                </div>
                <!-- <div class="col">
                  <select name="industry" v-model="form.industry" v-validate="'required'"
                          :class="(getError('industry') ? ' error' : '')" id="industry" :disabled="user">
                    <option value=''>Select industry</option>
                    <option :value="industry.id" v-for="industry in industries"
                            v-bind:key="industry.id">{{ industry.name }}
                    </option>
                  </select>
                  <span v-show="errors.has('industry')" class="help-block mt-1 p-1">The industry field is required.</span>
                </div> -->
                <div class="col">{{country}}
                  <select :class="(getError('countryid') ? ' error' : '')" name="countryid" id="countryid" v-model="form.countryid" v-validate="'required'" :disabled="user">
                    <option value=''>Select country</option>
                    <option v-for="country in countries" :selected="country == country.code ? 'selected' : ''" :value="country" v-bind:key="country.id">{{ country.name }}</option>
                  </select>
                  <span v-show="errors.has('countryid')"
                        class="help-block mt-1 p-1">The country field is required.</span>
                </div>
                <div class="col two-in">
                  <!--                <input type="password" :class="(getError('password') ? ' error' : '')" name="password" id="password"-->
                  <!--                       placeholder="Password" v-model="form.password"-->
                  <!--                       v-validate="'required'" autocomplete="new-password" :disabled="user">-->
                  <input type="password" :class="(getError('password') ? ' error' : '')" name="password" id="password"
                        ref="password" placeholder="Enter Password" v-model="form.password"
                        v-validate="'required|verify_password'" :disabled="user">
                  <input type="password" :class="(getError('confirm_password') ? ' error' : '')" name="confirm_password"
                        id="confirm_password" placeholder="Re-Enter password "
                        v-validate="'required|confirmed:password'" :disabled="user">
                        <span v-show="errors.has('password')" class="help-block mt-1 p-1">{{errors.first ('password')}}</span>
                  <span
                    v-show="errors.has('confirm_password') && errors.first('confirm_password') === 'The confirm_password confirmation does not match'"
                    class="help-block mt-1 p-1">The retype password confirmation does not match.</span>
                </div>
                <div class="col checkbox-sec">
                  <input type="checkbox" :class="(getError('confirm') ? ' error' : '')" v-model="form.confirm"
                        v-validate="'required'" name="confirm" :disabled="user"/>
                  <label
                  > I agree with <a href="https://www.b1g1.com/businessforgood/terms/" target="_blank">the terms of
                    B1G1</a> and
                    <a href="https://b1g1.com/businessforgood/b1g1-privacy-policy/" target="_blank">Privacy Policy</a>
                  </label>
                </div>
              </div>
              <span style="color:red" v-if="getError('confirm')">
                      Please read and accept our Terms and Conditions and Privacy Policy.
                    </span>
              <div class="col btn-sec text-center">
                <button type="button" class="b-btn white-btn" @click="goToBackStep()">BACK</button>
                <button type="button" class="b-btn red-btn" @click="submitTrial()" :disabled="isFormsubmited || user">
                  MAKE IT HAPPEN
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="trial-image-sec d-none d-sm-block">
              <img :src="imagePath">
              <div class="trial-img-content">
                <h3>{{ textHeading }}</h3>
                <p>{{ textContent }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <modal
        name="information-modal"
        id="information-modal"
        transition="pop-out"
        :width="880"
        :adaptive="true"
        :maxWidth="880"
        height="auto"
        :scrollable="true"
        class="full_width_mobile"
      >
        <div class="modal-content">
          <div class="modal-body pop-form">
            <section>
              <div class="text-center">
                <img src="/static/front/images/Group-118.png" alt=""/>
                <h3>
                  Congratulations! You just created your B1G1 Trial account and
                  an initial impact of 50 days of access to life-saving water.
                </h3>
                <p>
                  Small actions do make a difference. Explore some of the
                  exciting ways you can create impactful moments in your
                  business from as little as just 1 cent.
                </p>
                <h5>For example, imagine if....</h5>
                <div class="typing-main">
                  <p>
                    when you have a great meeting...<span
                  ><img src="/static/front/images/double.svg" alt=""
                  /></span>
                    child receives access to education
                  </p>
                </div>
                <a class="b-btn red-btn" href="#">ENTER B1G1 AND GET STARTED</a>
              </div>
            </section>
          </div>
        </div>
      </modal>
    </section>
    <footer>
      <div class="footer-logo"><a href="#"><img src="/static/front/images/white-footer-logo-new.png" alt=""/></a></div>
      <ul class="footer-menu">
        <li><a href="https://b1g1.com" target="_blank">B1G1 Home</a></li>
        <li><a href="https://b1g1.com/about-us" target="_blank">About</a></li>
        <li><a href="https://b1g1.com/terms-and-conditions-effective-from-1-apr-2023" target="_blank">Terms
          of Use</a></li>
        <li><a href="https://b1g1.com/privacy-policy" target="_blank">Privacy Policy</a></li>
      </ul>
    </footer>
  </div>
</template>
<script>
import Vue from 'vue'
import NotificationMixin from '../../helper/mixin/Notification'
// import contributionHelper from '../../helper/contribution'
import Notify from 'vue2-notify'
import userAPI from '../../api/user'
import trialAccountAPI from '../../api/trialAccount'
import appAPI from '../../api/app'
import VeeValidate from 'vee-validate'
import Tooltip from 'vue-directive-tooltip'
import Cookie from 'vue-js-cookie'
import config from '../../config/app'
import store from '../../store'
import axios from 'axios'
// import VueGtag from 'vue-gtag'
Vue.use(Notify)
Vue.use(VeeValidate)
Vue.use(Tooltip, {class: 'tooltip-info'})
/* Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
}) */
// Vue.use(VueGtag, {
//   config: {
//     id: 'G-S4V49H0PZH',
//     'debug_mode': true
//   }
// })
VeeValidate.Validator.extend('verify_password', {
  getMessage: field => `The password must be minimum six characters contain at least: 1 uppercase letter, 1 lowercase letter, 1 number`,
  validate: value => {
    var strongRegex = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,}$')
    return strongRegex.test(value)
  }
})
export default {
  mixins: [NotificationMixin],
  watch: {},
  methods: {
    getUserWarningAlert () {
      if (this.user != null) {
        this.bToast('error', 'You are currently logged in as a member and cannot fill this form.')
      }
    },
    goToBackStep () {
      this.step = 1
    },
    submitImpact () {
      if (this.form.project.id !== '') {
        // this.$gtag.event('Submitted Impact ', {
        //   event_category: 'Submitted_Impact ',
        //   event_label: 'submitted_impact',
        //   value: 'Yes'
        // })
        window.gtag('event', 'TRIAL3 Submitted Impact', {
          event_category: 'TRIAL3_Submitted_Impact',
          event_label: 'TRIAL3_Submitted_Impact',
          value: 'Yes'
        })
        this.step = 2
        this.topHeading = 'NOW, YOU CAN START A TRIAL EXPERIENCE WITH $1 ON US.'
        this.topText = "The $1 you receive is used to make the impact you've chosen. You can create more impacts during your 17-day trial, starting today."
      } else {
        this.errorMsg = 1
      }
    },
    getStarted () {
      this.step = 1
      // this.$gtag.event('TRIAL1 Clicked Start Button', {
      //   event_category: 'TRIAL1_Clicked_Start_Button',
      //   event_label: 'TRIAL1_Clicked_Start_Button',
      //   value: 'Yes'
      // })
      window.gtag('event', 'TRIAL1 Clicked Start Button', {
        event_category: 'TRIAL1_Clicked_Start_Button',
        event_label: 'TRIAL1_Clicked_Start_Button',
        value: 'Yes'
      })
      // this.trackEvent({ category: 'Trial_registration', label: 'clicked_trial_button', value: 'Yes' })
    },
    getCountryName (id) {
      return this.countries.filter(i => i.id === id).length > 0 ? this.countries.filter(i => i.id === id)[0].name : ''
    },
    submitTrial () {
      this.isFormsubmited = true
      this.loader = true
      // this.$gtag.event('Filled in the form', {
      //   event_category: 'Filled_In_The_Form',
      //   event_label: 'filled_in_the_form',
      //   value: 'Yes'
      // })
      window.gtag('event', 'TRIAL4 Filled In The Form', {
        event_category: 'TRIAL4_Filled_In_The_Form',
        event_label: 'TRIAL4_Filled_In_The_Form',
        value: 'Yes'
      })
      if (localStorage.getItem('trial_refer_code')) {
        console.log('get item', localStorage.getItem('trial_refer_code'))
        this.form.referal_code = localStorage.getItem('trial_refer_code')
      }
      let data = this.form
      data.register_source = this.register_source
      data.user_business.company.company_name = this.form.company
      // data.user_business.company.industry_1 = this.form.industry
      data.user_business.company.country_id = this.form.countryid.id
      data.user_business.country_id = this.form.countryid.id
      data.user_business.company.country_name = this.form.countryid.name
      data.user_business.company.country_code = this.form.countryid.dialing_code
      // this.loginArray['username'] = this.form.email
      // this.loginArray['password'] = this.form.password
      // console.log(this.loginArray)
      // console.log(this.$validator.validateAll(data))
      // console.log( this.form.countryid)
      // console.log(data)
      // return false
      this.$validator.validateAll(data).then((res) => {
        if (res) {
          // console.log('valid')
          trialAccountAPI.createAccount(data).then((response) => {
            if (response['status'] === 'error') {
              this.isFormsubmited = false
              this.loader = false
              this.bToast('error', 'Something went wrong. Please try again')
            } else {
              // this.isFormsubmited = false
              console.log('console.log(1234)')
              this.bToast('success', 'Your account has been successfully created.')
              // this.$gtag.event('Trial started', {
              //   event_category: 'Trial_Started',
              //   event_label: 'trial_started',
              //   value: 'Yes'
              // })
              window.gtag('event', 'TRIAL5 Trial Started', {
                event_category: 'TRIAL5_Trial_Started',
                event_label: 'TRIAL5_Trial_Started',
                value: 'Yes'
              })
              if (localStorage.getItem('trial_refer_code')) {
                localStorage.removeItem('trial_refer_code')
              }
              // this.$router.push({name: 'trial-account'})
              Cookie.set('username', this.form.email)
              let loginData = {
                username: this.form.email,
                password: this.form.password
              }
              this.$store.dispatch('login', loginData).then(() => {
                console.log('c122)')
                this.isFormsubmited = false
                this.saveUserLogin(this.form.email, this.form.password)
              }, () => {
                console.log('erro)')
                this.display.login_error = 'Wrong credentials'
              })
            }
          })
        } else {
          this.isFormsubmited = false
          this.loader = false
          this.bToast('error', 'Please fill red fields.')
          return false
        }
      })
    },
    saveUserLogin (username, password) {
      let reloadUrl = localStorage.getItem('b1g1_reload_url')
      userAPI.saveUserLogin(username).then((response) => {
        this.waiting = false
        console.log('saveUserLogin')
        console.log(response)
        if (response.status === 'error') {
          console.log('login error')
          this.display.login_error = response.error_msg
          this.$store.dispatch('logout')
        } else {
          console.log(response.user_type)
          if (response.user_type === 'business') {
            localStorage.setItem('b1g1_reload_url', '')
            if (reloadUrl === '' || reloadUrl === null) {
              let segments = window.location.pathname.split('/')
              console.log('segments: ' + segments)
              if (segments[1] === 'login' || segments[1] === 'businessforgood' || segments[1] === 'trial-registration') {
                location.href = config.host + '/impact'
              } else {
                window.location.reload()
              }
            } else {
              location.href = reloadUrl
            }
          } else {
            if (response.user_type === 'admin') {
              localStorage.setItem('login_user_type', 'admin')
              localStorage.setItem('YUJAqQWVZTRRJsvPpKIG', btoa(username))
              localStorage.setItem('VxdqRJrxxGTZSSwFmmOU', btoa(password))
              localStorage.setItem('b1g1_reload_url', '')
            }
            location.href = config.host + '/'
          }
        }
      }, () => {
        this.waiting = false
      })
    },
    checkAlphabetsOnly (strEleId) {
      // To check only alphabets allowed
      let getEleId = strEleId
      var textInput = document.getElementById(getEleId).value
      textInput = textInput.replace(/[^A-Za-z0-9&\- ']/g, '')
      document.getElementById(getEleId).value = textInput
    },
    getError (name) {
      // console.log(`valid name ${name}`, this.errors)
      return this.errors.items.filter(i => i.field === name).length > 0
    },
    selectProject (data) {
      if (data !== '' && data === 'water') {
        this.form.project.id = 1382
        this.form.project.impact_level_id = 3011
        this.form.project.price = 0.02
        this.form.project.quantity = 50
        this.errorMsg = 0
        this.imagePath = '/static/front/images/water.png'
        this.textHeading = 'GIFT OF WATER'
        this.textContent = 'Even today, nearly 650 million people do not have access to clean water. Through B1G1, you can help one person gain access to clean water for a day for as little as a few cents.'
        this.waterProjSelected = 'plan-active'
        this.treeProjSelected = ''
        this.educationProjSelected = ''
      } else if (data !== '' && data === 'tree') {
        this.form.project.id = 1380
        this.form.project.impact_level_id = 3009
        this.form.project.price = 1
        this.form.project.quantity = 1
        this.errorMsg = 0
        this.imagePath = '/static/front/images/tree.png'
        this.textHeading = 'PRESERVING FORESTS'
        this.textContent = 'B1G1’s tree-planting projects around the world not only help people plant new trees in their communities and forests, but also spread awareness of the importance of conservation.'
        this.waterProjSelected = ''
        this.treeProjSelected = 'plan-active'
        this.educationProjSelected = ''
      } else if (data !== '' && data === 'education') {
        this.form.project.id = 1381
        this.form.project.impact_level_id = 3010
        this.form.project.price = 0.2
        this.form.project.quantity = 5
        this.errorMsg = 0
        this.imagePath = '/static/front/images/education.png'
        this.textHeading = 'QUALITY EDUCATION'
        this.textContent = '244 million children between the age of 6-18 are currently missing out on school. By creating this impact, you’re helping provide access to education to children in need.'
        this.waterProjSelected = ''
        this.treeProjSelected = ''
        this.educationProjSelected = 'plan-active'
      }
      // this.$gtag.event('Selected Impact', {
      //   event_category: 'Selected_Impact',
      //   event_label: 'selected_impact',
      //   value: 'Yes'
      // })
      window.gtag('event', 'TRIAL2 Selected Impact', {
        event_category: 'TRIAL2_Selected_Impact',
        event_label: 'TRIAL2_Selected_Impact',
        value: 'Yes'
      })
    }
  },
  created () {
    console.log(this.$route.query)
    // fir referal code store
    if (this.$route.query && this.$route.query.code && this.user == null) {
      localStorage.setItem('trial_refer_code', this.$route.query.code ? this.$route.query.code : null)
    } else {
      localStorage.removeItem('trial_refer_code')
    }
    appAPI.getIndustries().then((response) => {
      this.industries = response
    })
    appAPI.getCountries().then((response) => {
      this.countries = response
      axios.get('https://api.ipify.org?format=json').then(response => {
        const ipAddress = response.data.ip
        axios.get(`https://ipapi.co/${ipAddress}/json/`).then(response => {
          this.isLoading = false
          this.location = response.data.country_code
          this.form.countryid = 'IN'
          this.countries.forEach((country) => {
            if (country.code === this.location) {
              this.form.countryid = country
            }
          })
        })
          .catch(error => {
            this.isLoading = false
            this.error = error.message
          })
      })
        .catch(error => {
          this.isLoading = false
          this.error = error.message
        })
    })
    this.$validator.extend('uniqueEmail', {
      getMessage: field => 'The email you tried to use exists on our system already. Please login and update your account or use another email address to create a new account.',
      validate: (value) => {
        return userAPI.checkEmailFree(value)
      }
    })
  },
  data () {
    return {
      loader: false,
      step: 0,
      location: null,
      user: (store.getters.currentUser) ? store.getters.currentUser : null,
      industries: [],
      countries: [],
      country: '',
      projectId: '',
      register_source: 'trial-online',
      isFormsubmited: false,
      form: {
        first_name: null,
        last_name: null,
        email: null,
        company: null,
        industry: '',
        countryid: '',
        retype_password: null,
        confirm: false,
        password: null,
        role_id: 7,
        referal_code: null,
        user_business: {
          type_reg: 'other',
          country_id: '',
          company: {
            country_id: '',
            company_name: null,
            employee_limit: 0,
            token_management_access: '1',
            engagement_access: '1',
            industry_1: ''
          }
        },
        project: {
          id: '',
          impact_level_id: '',
          quantity: '',
          price: ''
        }
      },
      waterProjSelected: '',
      treeProjSelected: '',
      educationProjSelected: '',
      imagePath: '/static/front/images/trial-img-1.png',
      textHeading: 'SEE WHAT $1 CAN DO',
      textContent: 'B1G1 allows you to maximize the impact you can have in the world by breaking down global projects into micro impacts.',
      errorMsg: 0,
      topHeading: 'FIRST, CHOOSE THE IMPACT YOU WANT TO CREATE',
      topText: ''
    }
  }
}
</script>
<style scoped>
p.warning-text {
  color: #fa0c0c;
  padding-left: 14px;
  font-size: 14px;
}

button.b-btn.white-btn {
    height: 50px;
    width: calc(50% - 14px);
    background-color: #d1cecea1;
    line-height: 18px;
    color: #000 !important;
}
.trial-form .col button.b-btn.white-btn:hover {
    background: #ccc;
}

.trial-re-header {
  box-shadow: none;
  border-top: 15px solid #00b4ef;
  padding-top: 0;
  flex: 0 0 100%;
}
.red-btn:disabled {
  color: #fff;
  background: #e88161;
  cursor: not-allowed;
}

.trial-re-header .logo-d {
  max-width: 310px;
}

footer {
  background: #00b4ef;
    text-align: center;
    color: #fff;
    padding: 10px 0px 50px 0px;
    margin-top: 60px;
    position: relative;
    z-index: 1;
    flex: 0 0 100%;
}

footer p {
  margin: 0px;
}

.trial-main .trial-ti-sec h2 {
  color: #000;
  font-size: 32px;
  font-weight: 500;
  line-height: 46px;
  margin-top: 30px;
  margin-bottom: 10px;
  letter-spacing: 0;
  padding-right: 20px;
}

.trial-ti-sec p {
  font-size: 16px;
  color: #000;
}

.trial-plan aside {
  background: #f7f7f7;
  border-radius: 5px;
  padding: 20px;
  text-align: center;
  width: 180px;
  cursor: pointer;
}

.trial-plan {
  display: flex;
  column-gap: 20px;
}

.trial-plan aside h4 {
  color: #000;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 20px;
  min-height: 71px;
  letter-spacing: 0;
}

.trial-plan aside img {
  width: 82px;
}

.btn-sec {
  margin-top: 30px;
}

.btn-sec .b-btn.red-btn {
  width: 50%;
  height: 50px;
  line-height: 39px;
  font-size: 18px;
  font-weight: 500;
}
.trial-plan aside:hover {
    background: #c9e5fa;
}
.trial-img-content {
  background-image: url(/static/front/images/Ellipse24.png);
  width: 563px;
  height: 406px;
  position: absolute;
  text-align: right;
  bottom: -150px;
  right: -70px;
  padding: 110px 120px 0px 160px;
}

.trial-image-sec {
  position: relative;
}

.trial-img-content h3 {
  font-size: 24px;
  font-weight: 500;
  color: #000;
}

.trial-img-content p {
  color: #000;
}

.trial-form {
  max-width: 390px;
  margin: auto;
  margin-top: 40px;
}

.trial-form [type="text"],
.trial-form [type="email"],
.trial-form [type="password"],
.trial-form select {
  border: 1px solid #363537;
  height: 38px;
  width: 100%;
  padding: 0px 10px;
  font-size: 14px;
  font-weight: 500;
}

.trial-form .col {
  margin-bottom: 14px;
}

.trial-form .col.two-in {
  display: flex;
  column-gap: 14px;
}

::placeholder {
  color: #808080 !important;
  opacity: 1;
  font-weight: 300;
}

::-webkit-input-placeholder {
  color: #808080 !important;
  opacity: 1;
  font-weight: 300;
}

.error-me {
  padding-top: 20px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #f24b02;
}

.btn-sec .b-btn.red-btn:hover {
  color: #fff;
  background: #a93a17;
}

.plan-active {
  background: #c8e5fb !important;
}

/*==============popup css=======================*/
#information-modal .modal-body.pop-form {
  padding: 70px 120px;
  background-image: url(/static/front/images/popup-bg.png);
  background-repeat: no-repeat;
  background-position: left top;
}

#information-modal h3 {
  font-size: 20px;
  color: #000;
  letter-spacing: 0;
  text-transform: unset;
  line-height: 30px;
  margin: 20px 0px;
  font-family: "Ubuntu";
  font-weight: 600;
}

#information-modal p {
  font-size: 16px;
  color: #000;
  line-height: 22px;
}

#information-modal h5 {
  font-size: 16px;
  color: #000;
  letter-spacing: 0;
  text-transform: unset;
  line-height: 22px;
  font-family: "Ubuntu";
  font-weight: 500;
}

#information-modal a {
  width: 325px;
  height: 50px;
  font-weight: 500;
  font-size: 18px;
  line-height: 40px;
}

.text-center.link-sec {
  padding-top: 40px;
  color: #979797;
}

.text-center.link-sec a {
  margin: 0px 7px;
  font-weight: 600;
}
.trial-form .col.two-in input {
  flex: 0 0 calc(50% - 7px);
  max-width: calc(50% - 7px);
}

.trial-form .col.two-in {
  flex-wrap: wrap;
}

.trial-form .col.two-in span.help-block.mt-1.p-1 {
  flex: 0 0 100%;
}
.trial-form .col.two-in input {
    flex: 0 0 calc(50% - 7px);
    max-width: calc(50% - 7px);
}

.trial-form .col.two-in {
    flex-wrap: wrap;
}

.trial-form .col.two-in span.help-block.mt-1.p-1 {
    flex: 0 0 100%;
}
.footer-logo img {
    max-width: 317px;
}

ul.footer-menu {
    display: flex;
    padding: 0;
    justify-content: center;
    margin: 20px 0 0 0;
}

ul.footer-menu li a {
    color: #fff;
    border-right: 1px solid #fff;
    padding: 0 15px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    font-family: "Ubuntu";
}

ul.footer-menu li:last-child a {
    border-right: 0;
}
section.trial-main {
    padding-top: 50px;
    flex: 0 0 100%;
}
.trial-top-head{
  height: 100vh;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
}
/* ============================================= */

@media (min-width: 1200px) {
  .container {
    max-width: 1240px;
  }
}

@media (min-width: 992px) and (max-width: 1150px) {
  .trial-img-content {
    width: 490px;
    height: 276px;
    bottom: -130px;
    right: -40px;
    padding: 70px 60px 0px 130px;
    background-size: 100% 100%;
    background-position: center;
  }

  .trial-plan aside h4 {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    min-height: 58px;
  }
}

@media (max-width: 991px) {
  .trial-main .trial-ti-sec h2 {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    margin-top: 0px;
    text-align: left;
    padding: 0;
  }

  .trial-form .col.two-in {
    /* flex-direction: column; */
    row-gap: 14px;
  }

  .trial-ti-sec p {
    font-size: 14px;
    text-align: left;
  }

  footer p {
    padding: 0px 20px;
  }

  .trial-plan {
    flex-direction: column;
    position: relative;
  }

  .trial-plan aside {
    width: 285px;
    margin: auto;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row-reverse;
    text-align: left;
    column-gap: 20px;
    align-items: center;
  }

  .trial-plan aside h4 {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 0px;
    min-height: auto;
    letter-spacing: 0;
  }

  .trial-plan aside img {
    width: 60px;
  }

  .trial-img-content h3 {
    font-size: 20px;
  }

  .trial-img-content {
    width: 400px;
    height: 236px;
    bottom: -110px;
    right: -40px;
    padding: 60px 50px 0px 60px;
    background-size: 100% 100%;
    background-position: center;
  }

  .btn-sec .b-btn.red-btn {
    width: 285px;
  }

  .checkbox-sec {
    display: flex;
    align-items: flex-start;
    column-gap: 10px;
  }

  .checkbox-sec input {
    margin-top: 5px;
  }

  footer {
    padding: 30px 0px;
    margin-top: 110px;
  }

  .trial-form .col {
    padding: 0;
  }
  .trial-form .col.two-in input {
    flex: 0 0 auto !important;
    max-width: calc(50% - 7px);
}

.trial-form button.b-btn {
    width: 100% !important;
    margin-bottom: 15px;
}
.trial-form button.b-btn {
    width: 100% !important;
    margin-bottom: 15px;
}
section.trial-main {
    padding-top: 30px;
}
}
@media (max-width: 767px) {
.footer-logo img {
    max-width: 317px;
}

ul.footer-menu {
    display: flex;
    padding: 0;
    justify-content: center;
    margin: 20px 0 0 0;
}

ul.footer-menu li a {
    color: #fff;
    border-right: 1px solid #fff;
    padding: 0 15px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    font-family: "Ubuntu";
}

ul.footer-menu li:last-child a {
    border-right: 0;
}
.footer-logo img {
    max-width: 190px !important;
}
body ul.footer-menu li a {
    font-size: 13px !important;
    padding: 0 7px !important;
}

ul.footer-menu {
    margin-bottom: 50px !important;
}
.col.btn-sec.text-center {
    display: flex;
    flex-wrap: wrap-reverse;
}
.trial-form {
    margin-top: 0 !important;
}
.trial-ti-sec {
    padding: 0 15px;
}
.toast-top-center {
    top: 30px;
}

}
@media (max-width: 576px) {
  .trial-ti-sec p {
    text-align: center;
  }

  .trial-main .trial-ti-sec h2 {
    text-align: center;
  }

  .trial-plan aside {
    margin-bottom: 15px;
  }

  .trial-image-sec {
    margin-bottom: 90px;
  }

  .error-me {
    max-width: 250px;
    margin: auto;
  }

  #information-modal .modal-body.pop-form {
    padding: 20px;
  }

  #information-modal h3 {
    font-size: 17px;
    line-height: 23px;
  }

  #information-modal a {
    width: auto;
  }

  .welcome-sec .row {
    display: flex;
    flex-direction: column-reverse;
  }

  .welcome-sec .row img {
    margin-bottom: 30px;
  }

  .welcome-sec .row .btn-sec {
    margin-top: 0px;
  }
}

@media (max-width: 400px) {
  .logo-d {
    width: 100%;
  }

  .btn-sec .b-btn.red-btn {
    width: 285px;
  }

  .trial-form .col {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/trial-registration/list.vue